// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1HHGL","content":"LayoutSettings_content__1hdJf"};